import { render } from "./NewMovies.vue?vue&type=template&id=61ebdcec"
import script from "./NewMovies.vue?vue&type=script&lang=js"
export * from "./NewMovies.vue?vue&type=script&lang=js"

import "./NewMovies.vue?vue&type=style&index=0&id=61ebdcec&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__